import React, { useState, useRef } from 'react';
import JoditEditor from 'jodit-react';
import Button from "react-bootstrap/Button";
import { addRecentIncidents } from "../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { POST_RECENT_INCIDENT_URL } from "../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import CustomSelect from "../../components/forms-fields/CustomSelectStaffMembers";
import Layout from '../../components/layouts/Layout';
import { Link } from 'react-router-dom';
import Input from '../../components/forms-fields/Input';
import moment from 'moment';

function AddRecentIncidents() {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddPbsPlans, setIsToastAddPbsPlans] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isStaffId, setIsStaffId] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
  };

  const editor = useRef(null);
  const [content, setContent] = useState('');

  const [suFormData, setSuFormData] = useState({

    userId: userDetails?._id,
    incidentTitle: "",
    incidentDate: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
    note: "",

  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addRecentIncidents,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postAddPbsPlansFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastAddPbsPlans(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);

    } else if (
      method === "postAddPbsPlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddPbsPlans(true);
      toastSuccessMessages(toast.success, data?.message, "/recent-incidents", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
      }, 2000);
    }
  };

  const postAddPbsPlansFormData = catchAsync(async (req, res) => {
    // console.log(values);
    const updatedValues = {
      ...values,
      incidentDate: moment(values.incidentDate).valueOf(),
      note: content,
    }
    const response = await postRecords(POST_RECENT_INCIDENT_URL, updatedValues);

    setIsSubmitButtonClicked(false);
    processPostRecords("postAddPbsPlansFormData", response);
  });



  const handleChangeTextEditor = (newContent) => {
    setContent(newContent);
    setFieldValue("note", newContent);
  };



  return (
    <>
      <Layout
        pageTitleText={
          <>
            Recent Incidents
          </>
        }
      >
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent">
            <div className="mainContentText">
              <h3>Add New Incident</h3>
              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row">
                    <div className="col-md-12">
                      <Input
                        type="datetime-local"
                        id="incidentDate"
                        name="incidentDate"
                        value={values?.incidentDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Incident Date"
                        customError={touched?.incidentDate && errors?.incidentDate}
                        errorMessage={errors?.incidentDate}
                        erroClass={
                          touched?.incidentDate && errors?.incidentDate
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>
                    <div className="col-md-12">
                      <Input
                        type="text"
                        id="incidentTitle"
                        name="incidentTitle"
                        value={values?.incidentTitle}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Incident Title"
                        customError={touched?.incidentTitle && errors?.incidentTitle}
                        errorMessage={errors?.incidentTitle}
                        erroClass={
                          touched?.incidentTitle && errors?.incidentTitle
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>
                    <div className="col-md-12">
                      <JoditEditor
                        ref={editor}
                        value={values?.note}
                        tabIndex={1}
                        onChange={handleChangeTextEditor}
                      />
                    </div>
                  </div>
                </div>
                <div className="formActionButtons mt-5">
                  <Link to="/recent-incidents">
                    <span
                      className="btn btn-sm btn-outline-primary"
                    >
                      Cancel
                    </span>
                  </Link>
                  {isSubmitButtonClicked ? (
                    <Button
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Save
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
      {isToastAddPbsPlans && <ToastContainer />}
    </>
  );
}

export default AddRecentIncidents;